/* scroll.lock.svg.js */

"use strict";

module.exports = {
    icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="-4.5 -2 23 35" fill="#2fabe2" xml:space="preserve">
        <path d="M13.7,9h-0.4c0-0.9,0-3.4,0-3.4C13.2,2.5,10.6,0,7.3,0C4,0,1.4,2.5,1.3,5.6V9H0.9C0.4,9,0,9.4,0,9.8V18
        c0,0.5,0.4,0.8,0.9,0.8h12.9c0.5,0,0.9-0.4,0.9-0.8V9.8C14.6,9.4,14.2,9,13.7,9z M10.6,9h-2v3.6c0.6,0,2.7-0.1,3.2-0.2
        c0.2,0,0.4,0.2,0.3,0.4L7.6,18c-0.1,0.2-0.4,0.2-0.5,0l-4.5-5.2c-0.1-0.2,0.1-0.4,0.3-0.4c0.6,0.1,2.7,0.2,3.3,0.2V9H4V5.6h0
        c0.1-1.7,1.5-3,3.3-3c1.8,0,3.2,1.3,3.3,3V9z"/>
    </svg>`,
};
